<template>
  <div class="index-page">
    <!-- 用户信息头卡 -->
    <div class="header-card">
      <div class="user-row">
        <img class="avatar" :src="userRes.headImageUrl ? userRes.headImageUrl : require('../assets/default_u.jpg')" alt="">
        <div class="user-info">
          <p class="name">{{ userRes.name }}<span class="uid" v-if="displayUid">ID：{{ displayUid }}</span></p>
          <div class="tags">
            <span class="role-tag" v-if="userRes.ltOfficer != 1 && userRes.role == '01'">分区经理</span>
            <span class="role-tag" v-if="userRes.ltOfficer != 1 && userRes.role == '00'">入职审核中</span>
            <span class="role-tag" v-if="userRes.ltOfficer == 1">管理员</span>
          </div>
        </div>
      </div>
      <div class="funds" v-if="userRes.role == '01' && !empLimited">
        <span class="funds-label">周转金总额（元）</span>
        <span class="funds-value">{{ userRes.revFunds || '0.00' }}</span>
      </div>
      <div class="header-actions" v-if="userRes.contactUrl">
        <span class="action-chip" @click="getContract(userRes.contactUrl)">查看合同</span>
        <span class="action-chip" @click="toUpdate">更新身份证</span>
      </div>
    </div>

    <!-- 业务列表 -->
    <div v-if="userRes.role && userRes.role != '00'" class="card biz-card">
      <!-- 消息中心：点击入口时先查公众号关注状态，未关注弹窗引导（不阻塞进入） -->
      <div class="biz-item" @click="jumpMessage">
        <div class="biz-icon">
          <van-badge :content="msgUnread || ''" :show-zero="false" max="99">
            <van-icon name="envelop-o" />
          </van-badge>
        </div>
        <div class="biz-main">
          <div class="biz-tit-row">
            <span class="biz-tit">消息中心</span>
          </div>
          <p class="biz-sub" v-if="msgUnread > 0">{{ msgUnread }} 条未读消息</p>
        </div>
        <van-button
          round
          size="small"
          class="biz-btn btn-gradient"
          @click.stop="jumpMessage"
          >查看</van-button>
      </div>

      <!-- 磐石转正·劳动关系：无档案或旧后端无此接口时不展示 -->
      <div class="biz-item" v-if="empDetail" @click="$router.push({ name: 'EmploymentView' })">
        <div class="biz-icon"><van-icon name="contact" /></div>
        <div class="biz-main">
          <div class="biz-tit-row">
            <span class="biz-tit">劳动关系</span>
            <span class="status-tag" :class="empStatusClass">{{ empStatusText }}</span>
          </div>
          <p class="biz-sub" v-if="empDetail.readOnly && empDetail.accessUntil">资料访问截止 {{ empDetail.accessUntil }}</p>
        </div>
        <van-button
          round
          size="small"
          class="biz-btn btn-gradient"
          @click.stop="$router.push({ name: 'EmploymentView' })"
          >{{ empDetail.signStatus === 'PENDING' && !empDetail.readOnly && empDetail.canResubmit !== false ? '去补资料' : '查看' }}</van-button>
      </div>

      <!-- 磐石转正生效或离职保留期（empLimited）：只保留消息中心和劳动关系两栏，其余业务条目隐藏 -->
      <template v-if="!empLimited">
      <div class="biz-item">
        <div class="biz-icon"><van-icon name="shop-collect-o" /></div>
        <div class="biz-main">
          <div class="biz-tit-row">
            <span class="biz-tit">营销证</span>
            <span class="status-tag" :class="'status-tag--' + (userRes.marketStatus == 0 ? 'warning' : userRes.marketStatus == 1 ? 'primary' : userRes.marketStatus == 2 ? 'danger' : 'success')">{{userRes.marketStatus == 0 ? '未交费' : userRes.marketStatus == 1 ? '审核中' : userRes.marketStatus == 2 ? '驳回' : userRes.trackNo ? '已邮寄' : '审核通过' }}</span>
          </div>
        </div>
        <van-button
          v-if="(userRes.marketStatus == 0 || userRes.marketStatus == 2) && !empReadOnly"
          round
          size="small"
          class="biz-btn btn-gradient"
          @click="jumpMarket"
          >上传照片</van-button>
      </div>

      <div class="biz-item">
        <div class="biz-icon"><van-icon name="idcard" /></div>
        <div class="biz-main">
          <div class="biz-tit-row">
            <span class="biz-tit">从业资格证</span>
            <span class="status-tag" :class="userRes.cyzgPicUrl ? 'status-tag--success' : 'status-tag--warning'">{{ userRes.cyzgPicUrl ? '已上传' : '待上传' }}</span>
          </div>
          <p class="biz-sub" v-if="userRes.cyzgPicUrl">如需更换可重新上传</p>
        </div>
        <div class="biz-btns">
          <van-button
            v-if="userRes.cyzgPicUrl"
            round
            size="small"
            class="biz-btn"
            @click="previewCyzg"
            >查看</van-button>
          <van-uploader v-if="!empReadOnly" :after-read="afterCyzgRead">
            <van-button
              round
              size="small"
              class="biz-btn btn-gradient"
              >{{ userRes.cyzgPicUrl ? '更新照片' : '上传照片' }}</van-button>
          </van-uploader>
        </div>
      </div>

      <div v-if="userRes.role == '01'" class="biz-item">
        <div class="biz-icon"><van-icon name="cash-back-record" /></div>
        <div class="biz-main">
          <div class="biz-tit-row">
            <span class="biz-tit">周转金</span>
            <span class="status-tag" :class="userRes.revFundsStatus == 0 ? 'status-tag--warning' : 'status-tag--success'">{{userRes.revFundsStatus == 0 ? '待缴费' : '已缴费'}}</span>
          </div>
          <p class="biz-link" @click="jumpFunds">周转金记录 <van-icon name="arrow" /></p>
        </div>
        <van-button
          v-if="userRes.revFundsStatus == 0 && !empReadOnly"
          round
          size="small"
          class="biz-btn btn-gradient"
          @click="jumpPayment"
          >立即缴费</van-button>
        <van-button
          v-else-if="!empReadOnly"
          round
          size="small"
          class="biz-btn btn-gradient"
          @click="applyRefund"
          >{{ userRes.applyRefund == 0 ? '申请退费' : '退费申请中' }}</van-button>
      </div>

      <div class="biz-item">
        <div class="biz-icon"><van-icon name="balance-list" /></div>
        <div class="biz-main">
          <div class="biz-tit-row">
            <span class="biz-tit">{{userRes.month}}月保险</span>
            <span class="status-tag" :class="userRes.insureStatus == 1 ? 'status-tag--success' : 'status-tag--warning'">{{userRes.insureStatus == 1 ? '已缴费' : '待缴费' }}</span>
          </div>
          <p class="biz-sub">当日购买保险，下午17点后可抽奖</p>
          <p class="biz-link" @click="insureRecord">投保记录 <van-icon name="arrow" /></p>
        </div>
        <span class="biz-hint" v-if="userRes.isWorkDay != 1 || timeNow > 12">工作日<br>12点前购买</span>
        <van-button
          v-else-if="userRes.insureStatus != 1 && !empSigned && !empReadOnly"
          round
          size="small"
          class="biz-btn btn-gradient"
          @click="jumpInsure"
          >开始投保</van-button>
      </div>

      <div class="biz-item">
        <div class="biz-icon"><van-icon name="cluster-o" /></div>
        <div class="biz-main">
          <div class="biz-tit-row">
            <span class="biz-tit">设备押金</span>
            <span class="status-tag" :class="(userRes.claimType == -1 || (userRes.claimType == 2 && userRes.depositStatus == 3 ) || userRes.claimType == 4) ? 'status-tag--warning' : 'status-tag--success'">{{userRes.claimType == -1 || (userRes.claimType == 2 && userRes.depositStatus == 3 ) || userRes.claimType == 4 ? '待缴费' : '已缴费' }}</span>
          </div>
          <p class="biz-link" @click="deviceRecord">缴费记录 <van-icon name="arrow" /></p>
        </div>
        <van-button
          v-if="userRes.refundStatus && userRes.refundStatus == 0"
          round
          size="small"
          class="biz-btn"
          disabled
          >退费中</van-button>
        <template v-else>
          <van-button
            v-if="(userRes.claimType == -1 || (userRes.claimType == 2 && userRes.depositStatus == 3 ) || userRes.claimType == 4) && !empReadOnly"
            round
            size="small"
            class="biz-btn btn-gradient"
            @click="payDkq"
            >缴费</van-button>
          <van-button
            v-if="userRes.claimType == 1 && userRes.useStatus > 1 && !empReadOnly"
            round
            size="small"
            class="biz-btn btn-gradient"
            @click="sPayDkq"
            >补缴</van-button>
          <van-button
            v-if="userRes.useStatus == -1 && userRes.claimType == 1 && !empReadOnly"
            round
            size="small"
            class="biz-btn btn-gradient"
            @click="refunds"
            >退费</van-button>
        </template>
      </div>

      <div class="biz-item" v-if="userRes.scenePhotoStatus !== undefined && userRes.scenePhotoStatus !== null">
        <div class="biz-icon"><van-icon name="photograph" /></div>
        <div class="biz-main">
          <div class="biz-tit-row">
            <span class="biz-tit">场景照片</span>
            <span class="status-tag" :class="sceneStatusClass">{{ sceneStatusText }}</span>
          </div>
          <p class="biz-sub" v-if="userRes.scenePhotoStatus == 1 && userRes.scenePhotoExpiresAt">有效期至 {{ userRes.scenePhotoExpiresAt }}</p>
          <p class="biz-sub scene-warn" v-else-if="[-1, 2, 3].indexOf(Number(userRes.scenePhotoStatus)) > -1">请如实上传真实工作场景照片，否则将影响佣金发放</p>
        </div>
        <van-uploader v-if="[-1, 2, 3].indexOf(Number(userRes.scenePhotoStatus)) > -1 && !empReadOnly" :after-read="afterSceneRead">
          <van-button
            round
            size="small"
            class="biz-btn btn-gradient"
            >{{ userRes.scenePhotoStatus == -1 ? '提交照片' : '更新照片' }}</van-button>
        </van-uploader>
      </div>

      <!-- 涉税信息报送（GN 税务签约，按启用公司分别签约）；无启用公司时不展示 -->
      <div class="biz-item" v-if="userRes.taxSignEnabledCount > 0">
        <div class="biz-icon"><van-icon name="edit" /></div>
        <div class="biz-main">
          <div class="biz-tit-row">
            <span class="biz-tit">涉税信息报送</span>
            <span class="status-tag" :class="userRes.allTaxSigned ? 'status-tag--success' : 'status-tag--warning'">{{ userRes.allTaxSigned ? '已签约' : `已签${userRes.taxSignSignedCount || 0}/${userRes.taxSignEnabledCount}` }}</span>
          </div>
        </div>
        <van-button
          round
          size="small"
          class="biz-btn btn-gradient"
          @click="$router.push({ name: 'TaxSignView' })"
          >{{ userRes.allTaxSigned ? '查看' : '去签约' }}</van-button>
      </div>
      </template>
    </div>

    <!-- 地市钉钉群二维码：按用户地市匹配，匹配不上不展示；磐石转正后不展示 -->
    <div class="card ding-card" v-if="dingQrImg && !empLimited">
      <div class="ding-tit">州市钉钉组织架构码</div>
      <img class="ding-qr" :src="dingQrImg" alt="地市钉钉群二维码" />
      <p class="ding-tip">使用钉钉扫一扫加入，或保存图片后识别</p>
    </div>

    <!-- 底部客服条 -->
    <div class="connect-bar" @click="show = true">
      <van-icon name="service-o" />
      <span>联系客服 / 出险报备</span>
    </div>
    <van-popup round v-model="show">
      <div class="connect-box">
        <p>180-8704-4757</p>
        <van-button
        round
        class="btn-gradient call-btn"
        url="tel:18087044757"
        >拨打电话</van-button>
      </div>
    </van-popup>
    <!-- 公众号关注引导：NOT_FOLLOWED 时弹出；关注不作为访问条件，暂不关注仍放行 -->
    <van-popup round v-model="followShow" @close="onFollowClose">
      <div class="follow-box">
        <div class="follow-tit">关注公众号</div>
        <img class="follow-qr" :src="gzhQrImg" alt="公众号二维码" />
        <p class="follow-tip">长按识别二维码关注公众号<br />及时接收消息通知</p>
        <van-button round block class="btn-gradient" :loading="followChecking" @click="confirmFollow">我已关注</van-button>
        <div class="follow-skip" @click="followShow = false">暂不关注</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Request } from '@/api/api.js'
import { ImagePreview } from 'vant'
import { wxConfig, wxPay } from '@/utils/wx.js'
import { uploadScenePhoto, uploadSingleFile } from '@/utils/upload.js'

// 公众号二维码（关注引导弹窗）
const GZH_QR_IMG = require('@/assets/gzh_qrcode.png')
// 关注引导弹窗每会话只自动弹一次（消息中心入口点击不受此限制）
const FOLLOW_PROMPT_KEY = 'gzhFollowPrompted'

// 地市钉钉群二维码（key 为去掉"市/州/地区"后缀的地市短名）
const DING_QR_MAP = {
  昆明: require('@/assets/dingtalk/kunming.jpg'),
  大理: require('@/assets/dingtalk/dali.jpg'),
  曲靖: require('@/assets/dingtalk/qujing.jpg'),
  玉溪: require('@/assets/dingtalk/yuxi.jpg'),
  保山: require('@/assets/dingtalk/baoshan.jpg'),
  昭通: require('@/assets/dingtalk/zhaotong.jpg'),
  丽江: require('@/assets/dingtalk/lijiang.jpg'),
  普洱: require('@/assets/dingtalk/puer.jpg'),
  临沧: require('@/assets/dingtalk/lincang.jpg'),
  楚雄: require('@/assets/dingtalk/chuxiong.jpg'),
  红河: require('@/assets/dingtalk/honghe.jpg'),
  文山: require('@/assets/dingtalk/wenshan.jpg'),
  版纳: require('@/assets/dingtalk/banna.jpg'),
  德宏: require('@/assets/dingtalk/dehong.jpg'),
  怒江: require('@/assets/dingtalk/nujiang.jpg'),
  迪庆: require('@/assets/dingtalk/diqing.jpg'),
  省分部: require('@/assets/dingtalk/shengfenbu.jpg')
}
// 磐石计划专用地市钉钉群二维码（与蓄能版同结构，图片不同）
const DING_QR_MAP_PANSHI = {
  昆明: require('@/assets/dingtalk/panshi/kunming.jpg'),
  大理: require('@/assets/dingtalk/panshi/dali.jpg'),
  曲靖: require('@/assets/dingtalk/panshi/qujing.jpg'),
  玉溪: require('@/assets/dingtalk/panshi/yuxi.jpg'),
  保山: require('@/assets/dingtalk/panshi/baoshan.jpg'),
  昭通: require('@/assets/dingtalk/panshi/zhaotong.jpg'),
  丽江: require('@/assets/dingtalk/panshi/lijiang.jpg'),
  普洱: require('@/assets/dingtalk/panshi/puer.jpg'),
  临沧: require('@/assets/dingtalk/panshi/lincang.jpg'),
  楚雄: require('@/assets/dingtalk/panshi/chuxiong.jpg'),
  红河: require('@/assets/dingtalk/panshi/honghe.jpg'),
  文山: require('@/assets/dingtalk/panshi/wenshan.jpg'),
  版纳: require('@/assets/dingtalk/panshi/banna.jpg'),
  德宏: require('@/assets/dingtalk/panshi/dehong.jpg'),
  怒江: require('@/assets/dingtalk/panshi/nujiang.jpg'),
  迪庆: require('@/assets/dingtalk/panshi/diqing.jpg'),
  省分部: require('@/assets/dingtalk/panshi/shengfenbu.jpg')
}
// 常见别名归一
const DING_REGION_ALIAS = {
  西双版纳: '版纳',
  省本部: '省分部'
}

export default {
  name: 'IndexView',
  data() {
    return {
      show: false,
      userRes: {},
      timeNow: 0,
      // 磐石转正档案：null 表示无档案/旧后端无接口，条目不展示
      empDetail: null,
      // 消息中心未读数（角标）；关注引导弹窗
      msgUnread: 0,
      followShow: false,
      // 弹窗关闭后要执行的跳转（'message'）；关注引导不阻塞业务进入
      followNav: '',
      // 「我已关注」刷新中状态（防重复点击）
      followChecking: false,
      gzhQrImg: GZH_QR_IMG
    }
  },
  async mounted() {
    wxConfig()
    this.getUserInfo()
    this.loadEmployment()
    this.loadUnread()
    this.checkFollowOnLoad()
    this.timeNow = new Date().getHours()
    // 引导弹窗打开期间，用户从微信关注页切回来时自动刷新关注状态
    document.addEventListener('visibilitychange', this.onFollowVisible)
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.onFollowVisible)
  },
  computed: {
    // 劳动关系状态标签：先判离职只读，再判线下待上传，最后按签署状态
    empStatusText() {
      const d = this.empDetail
      if (!d) return ''
      if (d.readOnly) return '已离职'
      if (d.signStage === 'WAITING_UPLOAD') return '待上传合同'
      return ({ PENDING: '待补资料', SIGNING: '待签署', SIGNED: '已生效' })[d.signStatus] || ''
    },
    empStatusClass() {
      const d = this.empDetail
      if (!d) return ''
      if (d.readOnly) return 'status-tag--danger'
      if (d.signStage === 'WAITING_UPLOAD') return 'status-tag--primary'
      return ({ PENDING: 'status-tag--warning', SIGNING: 'status-tag--primary', SIGNED: 'status-tag--success' })[d.signStatus] || ''
    },
    // 转正已生效：关停保险投保（劳动关系已建立，不再走原投保）
    empSigned() {
      return !!(this.empDetail && this.empDetail.signStatus === 'SIGNED' && !this.empDetail.readOnly)
    },
    // 离职保留期：关停全部办理类按钮，仅保留查询
    empReadOnly() {
      return !!(this.empDetail && this.empDetail.readOnly)
    },
    // 转正已生效或离职保留期：个人中心只保留消息中心和劳动关系两栏
    empLimited() {
      return this.empSigned || this.empReadOnly
    },
    // 场景照片状态：-1 未提交、0 待审核、1 已通过、2 已驳回、3 到期待更新
    sceneStatusText() {
      return ({ '-1': '未提交', 0: '待审核', 1: '已通过', 2: '已驳回', 3: '到期待更新' })[this.userRes.scenePhotoStatus] || ''
    },
    sceneStatusClass() {
      return ({
        '-1': 'status-tag--warning',
        0: 'status-tag--primary',
        1: 'status-tag--success',
        2: 'status-tag--danger',
        3: 'status-tag--warning'
      })[this.userRes.scenePhotoStatus] || ''
    },
    // 地市钉钉群二维码：region 去掉"市/州/地区"后缀后匹配，匹配不上不展示
    // 磐石计划人员（getUserInfo 返回 roleType=5，与 role 含义不同）单独使用磐石版二维码
    dingQrImg() {
      const raw = (this.userRes.region || '').trim()
      if (!raw) return ''
      const key = raw.replace(/(自治州|地区|市|州)$/, '')
      const map = Number(this.userRes.roleType) === 5 ? DING_QR_MAP_PANSHI : DING_QR_MAP
      return map[DING_REGION_ALIAS[key] || key] || ''
    },
    // 用户ID：优先取 getUserInfo 返回的 uid，兜底登录时存的 userData.uid
    displayUid() {
      if (this.userRes.uid) return this.userRes.uid
      try {
        const userData = JSON.parse(localStorage.getItem('userData'))
        return (userData && userData.uid) || ''
      } catch (e) {
        return ''
      }
    }
  },
  methods: {
    // 场景照片：上传 → 提交进入审核（审核结果通过消息中心通知，不再拉起订阅弹窗）
    async afterSceneRead(file) {
      const res = await uploadScenePhoto(file.file)
      const url = res.data && res.data.url
      if (!url) {
        return this.$toast(res.resultDesc || '上传失败，请重试')
      }
      await Request.scenePhotoSubmit({ scenePhotoUrl: url })
      this.$toast('提交成功，等待审核')
      this.getUserInfo()
    },
    // 从业资格证照片：上传 → 独立接口保存（不再随营销证下单提交）
    async afterCyzgRead(file) {
      const res = await uploadSingleFile(file.file)
      const url = res.data && res.data.url
      if (!url) {
        return this.$toast(res.resultDesc || '上传失败，请重试')
      }
      await Request.cyzgPicSubmit({ cyzgPicUrl: url })
      this.$toast('提交成功')
      this.getUserInfo()
    },
    // 查看已上传的从业资格证照片
    previewCyzg() {
      if (!this.userRes.cyzgPicUrl) return
      ImagePreview({ images: [this.userRes.cyzgPicUrl], closeable: true })
    },
    toUpdate() {
      this.$router.push({ name: "UpdateUser" });
    },
    async getUserInfo() {
      const userRes = await Request.getUserInfo({})
      // 新注册用户档案未生成时后端可能返回 data: null，兜底防渲染崩溃
      this.userRes = userRes.data || {}
    },
    // 静默探测劳动关系档案：raw 模式自行判断业务码，无档案或旧后端无接口时静默隐藏入口
    async loadEmployment() {
      try {
        const res = await Request.employmentDetail({}, { raw: true, silent: true })
        if (res && (res.code == 0 || res.resultCode == 0) && res.data) {
          this.empDetail = res.data
        }
      } catch (e) {
        // 兼容旧后端：探测失败不提示、不展示入口
      }
    },
    // 静默拉取未读数：raw 模式自行判断业务码，兼容无此接口的旧后端
    async loadUnread() {
      try {
        const res = await Request.messageUnread({}, { raw: true, silent: true })
        if (res && (res.code == 0 || res.resultCode == 0)) {
          this.msgUnread = Number(res.data) || 0
        }
      } catch (e) {
        // 角标失败静默
      }
    },
    // 首页加载及页面恢复可见时都会查询关注状态；会话标记只控制弹窗频次，不阻止查询（文档 3.1）
    async checkFollowOnLoad() {
      const status = await this.queryFollowStatus()
      if (status === 'NOT_FOLLOWED' && !sessionStorage.getItem(FOLLOW_PROMPT_KEY)) {
        sessionStorage.setItem(FOLLOW_PROMPT_KEY, '1')
        this.followShow = true
      }
    },
    // 消息中心入口：点击时判断关注状态；关注不作为访问条件，引导后仍放行
    async jumpMessage() {
      const status = await this.queryFollowStatus()
      if (status === 'NOT_FOLLOWED') {
        this.followNav = 'message'
        this.followShow = true
        return
      }
      if (status === 'UNKNOWN') {
        this.$toast('关注状态查询失败，请稍后重试')
      }
      this.$router.push({ name: 'MessageView' })
    },
    // followStatus 返回 FOLLOWED/NOT_FOLLOWED/UNKNOWN；接口失败按 UNKNOWN 放行（不阻塞业务）
    // refresh=true 让后端绕过 5 分钟缓存实时查询微信（30 秒内不会重复刷新成功观测）
    async queryFollowStatus(refresh) {
      try {
        const res = await Request.messageFollowStatus({ refresh: !!refresh }, { raw: true, silent: true })
        if (res && (res.code == 0 || res.resultCode == 0) && res.data) {
          return res.data.status || 'UNKNOWN'
        }
      } catch (e) {
        // 旧后端无接口/网络异常：按 UNKNOWN 放行
      }
      return 'UNKNOWN'
    },
    // 「我已关注」：强制刷新关注状态，已关注则关闭弹窗（onFollowClose 执行挂起的跳转）
    async confirmFollow() {
      if (this.followChecking) return
      this.followChecking = true
      try {
        const status = await this.queryFollowStatus(true)
        if (status === 'FOLLOWED') {
          this.followShow = false
        } else if (status === 'NOT_FOLLOWED') {
          this.$toast('暂未检测到关注，请稍后再试')
        } else {
          this.$toast('关注状态查询失败，请稍后重试')
        }
      } finally {
        this.followChecking = false
      }
    },
    // 页面恢复可见时重新查询关注状态（文档 3.1）；
    // 弹窗打开期间则按「刚去微信完成关注」处理，强制刷新一次，已关注直接关弹窗继续跳转
    async onFollowVisible() {
      if (document.visibilityState !== 'visible') return
      if (!this.followShow) {
        this.checkFollowOnLoad()
        return
      }
      if (this.followChecking) return
      this.followChecking = true
      try {
        const status = await this.queryFollowStatus(true)
        if (status === 'FOLLOWED') {
          this.followShow = false
        }
      } finally {
        this.followChecking = false
      }
    },
    // 引导弹窗关闭后执行挂起的跳转
    onFollowClose() {
      if (this.followNav === 'message') {
        this.followNav = ''
        this.$router.push({ name: 'MessageView' })
      }
    },
    async refunds() {
      await Request.refundDkq({})
      this.$toast({
        message: `操作成功！`,
        duration: 2000,
      });
      setTimeout(async () => {
        this.getUserInfo()
      }, 2000);
    },
    async payDkq() {
      const res = await Request.payDkq({})
      this.handleDkqPay(res.data)
    },
    async sPayDkq() {
      const res = await Request.sPayDkq({})
      this.handleDkqPay(res.data)
    },
    async handleDkqPay(data) {
      try {
        await wxPay(data)
        this.$toast({
          message: `支付成功！`,
          duration: 2000,
        });
        setTimeout(() => {
          this.getUserInfo()
        }, 2000);
      } catch (e) {
        console.log('wxPay fail', e)
        this.$toast({
          message: `支付未完成`,
          duration: 2000,
        });
      }
    },
    async applyRefund() {
      if (this.userRes.applyRefund == 1) return
      if (!this.isMoreThan24Hours(this.userRes.createAt)) {
        this.$toast({
          message: `注册未满24小时，暂不能申请退费！`,
          duration: 2000,
        });
        return
      }
      await Request.applyRefund({})
      this.getUserInfo()
      this.$toast({
        message: `申请成功！`,
        duration: 2000,
      });
    },
    isMoreThan24Hours(timeStr) {
      // 将时间字符串转换为Date对象
      const targetTime = new Date(timeStr.replace(' ', 'T'));

      // 获取当前时间
      const currentTime = new Date();

      // 计算时间差（毫秒）
      const timeDifference = Math.abs(targetTime - currentTime);

      // 24小时的毫秒数
      const twentyFourHours = 24 * 60 * 60 * 1000;

      // 返回比较结果
      return timeDifference > twentyFourHours;
    },
    jumpPayment() {
      this.$router.push({
        name: 'PaymentView'
      })
    },
    jumpFunds() {
      this.$router.push({
        name: 'FundRecordView'
      })
    },
    jumpMarket() {
      this.$router.push({
        name: 'InfoView'
      })
    },
    insureRecord() {
      this.$router.push({
        name: 'InsuranceRecordView'
      })
    },
    deviceRecord() {
      this.$router.push({
        name: 'DeviceRecordView'
      })
    },
    jumpInsure() {
      this.$router.push({
        name: 'InsuranceDetailView',
        query: {
          insureId: this.userRes.insureId
        }
      })
    },
    getContract(url) {
      window.open(url)
    }
  },
}
</script>

<style scoped>
.index-page {
  min-height: 100vh;
  box-sizing: border-box;
  background: var(--page-bg);
  padding: 24px 24px 140px;
}

/* 用户信息头卡 */
.header-card {
  background: var(--brand-gradient);
  border-radius: 20px;
  padding: 40px 32px;
  box-shadow: 0 8px 24px rgba(46, 119, 230, 0.35);
  margin-bottom: 24px;
}
.user-row {
  display: flex;
  align-items: center;
}
.avatar {
  display: block;
  width: 110px;
  height: 110px;
  border-radius: 50%;
  border: 4px solid rgba(255, 255, 255, 0.4);
  margin-right: 24px;
}
.name {
  font-size: 40px;
  font-weight: bold;
  color: #fff;
  margin: 0 0 12px;
}
.uid {
  margin-left: 16px;
  font-size: 24px;
  font-weight: normal;
  color: rgba(255, 255, 255, 0.85);
}
.role-tag {
  display: inline-block;
  padding: 4px 20px;
  border-radius: 20px;
  font-size: 22px;
  color: #fff;
  background: rgba(255, 255, 255, 0.22);
}
.funds {
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.25);
  display: flex;
  flex-direction: column;
}
.funds-label {
  font-size: 24px;
  color: rgba(255, 255, 255, 0.75);
}
.funds-value {
  margin-top: 8px;
  font-size: 56px;
  font-weight: bold;
  color: #fff;
  line-height: 1.2;
}
.header-actions {
  margin-top: 24px;
  display: flex;
}
.action-chip {
  padding: 8px 24px;
  border-radius: 24px;
  font-size: 24px;
  color: #fff;
  background: rgba(255, 255, 255, 0.22);
  margin-right: 20px;
}

/* 业务列表卡 */
.biz-card {
  padding: 8px 28px;
}
.biz-item {
  display: flex;
  align-items: center;
  padding: 32px 0;
  border-bottom: 1px solid #f0f2f5;
}
.biz-item:last-child {
  border-bottom: none;
}
.biz-icon {
  flex-shrink: 0;
  width: 72px;
  height: 72px;
  border-radius: 20px;
  background: var(--brand-light);
  color: var(--brand-deep);
  font-size: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 24px;
}
.biz-main {
  flex: 1;
  min-width: 0;
}
.biz-tit-row {
  display: flex;
  align-items: center;
}
.biz-tit {
  font-size: 30px;
  font-weight: bold;
  color: var(--text-main);
  margin-right: 16px;
  white-space: nowrap;
}
/* 一个条目多个按钮时纵向堆叠，避免挤压标题和状态标签 */
.biz-btns {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.biz-btns .biz-btn + .van-uploader,
.biz-btns .van-uploader + .biz-btn {
  margin-top: 12px;
}
.biz-sub {
  font-size: 22px;
  color: var(--text-weak);
  margin: 8px 0 0;
}
.biz-link {
  font-size: 24px;
  color: var(--brand-deep);
  margin: 8px 0 0;
  display: inline-flex;
  align-items: center;
}
.biz-hint {
  flex-shrink: 0;
  font-size: 20px;
  color: var(--text-weak);
  text-align: center;
  line-height: 1.4;
}
.scene-warn {
  color: var(--warning);
}
.biz-btn {
  flex-shrink: 0;
  min-width: 144px;
  font-size: 24px;
}

/* 地市钉钉群二维码 */
.ding-card {
  padding: 32px 28px;
  margin-bottom: 24px;
  text-align: center;
}
.ding-tit {
  font-size: 30px;
  font-weight: bold;
  color: var(--text-main);
  margin-bottom: 24px;
  text-align: left;
}
.ding-qr {
  width: 360px;
  height: 360px;
  display: block;
  margin: 0 auto;
}
.ding-tip {
  margin: 20px 0 0;
  font-size: 24px;
  color: var(--text-weak);
}

/* 底部客服条 */
.connect-bar {
  position: fixed;
  left: 24px;
  right: 24px;
  bottom: calc(24px + env(safe-area-inset-bottom));
  height: 88px;
  background: #fff;
  border-radius: 44px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: var(--brand-deep);
}
.connect-bar .van-icon {
  font-size: 36px;
  margin-right: 12px;
}
.connect-box {
  width: 440px;
  padding: 48px 32px;
  text-align: center;
  font-size: 40px;
  font-weight: bold;
}
.call-btn {
  margin-top: 32px;
  border: none;
  font-size: 30px;
}
.follow-box {
  width: 520px;
  padding: 48px 40px;
  text-align: center;
}
.follow-tit {
  font-size: 34px;
  font-weight: bold;
  color: var(--text-main);
  margin-bottom: 32px;
}
.follow-qr {
  width: 360px;
  height: 360px;
  display: block;
  margin: 0 auto;
}
.follow-tip {
  font-size: 26px;
  color: var(--text-sub);
  line-height: 1.6;
  margin: 24px 0 32px;
}
.follow-skip {
  margin-top: 28px;
  font-size: 26px;
  color: var(--text-weak);
}
</style>
